'use strict';
  
angular.module('buyersService')
.factory('ContactService', ['appInfo', '$log', '$rootScope', '$http', '$q', 'CacheFactory', 
    function (appInfo, $log, $rootScope, $http, $q, CacheFactory) {
        var service = {}
            , code    = $rootScope.currentUser.authdata
            , expires =  moment().add(15, 'm').unix();

        var agencyCache;

        if (!CacheFactory.get('contactCache')) {
          agentCache = CacheFactory('contactCache', {
                          maxAge: 15 * 60 * 1000,
                          deleteOnExpire: 'aggressive'
                        });
        }

        // getListings method which will fetch data from API and *returns* a promise
        service.contact = function(usercode, ref) {
            var dfd = $q.defer();
            
            $http({
                    url: appInfo.endpoint+'otherusers/agent.json', 
                    method: "GET",
                    params: {usercode: usercode, contact: ref, api_key: appInfo.key},
                    cache: CacheFactory.get('contactCache')
                }).success(function(data) {
                    dfd.resolve(data);
                }).error(function(data, status, headers, config) {
                    dfd.reject("Error: request returned status " + status); 
                });

            return dfd.promise;

        };
        
        return service;

}]);